module.exports = __webpack_public_path__ + "img/mem_usage.1522b76d.png";